"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiShareLinksClient = void 0;
const ApiSubClient_1 = require("../../common/client/ApiSubClient");
const expandUrlTemplate_1 = __importDefault(require("../../common/utils/expandUrlTemplate"));
class ApiShareLinksClient extends ApiSubClient_1.ApiSubClient {
    trackCollectionShareLink(collectionId) {
        const trackCollectionShareLink = this.getLinkOrThrow('trackCollectionShareLink');
        return this.axios.post((0, expandUrlTemplate_1.default)(trackCollectionShareLink.href, {
            id: collectionId,
        }), {});
    }
    trackVideoShareLink(videoId) {
        const trackVideoShareLink = this.getLinkOrThrow('trackVideoShareLink');
        return this.axios.post((0, expandUrlTemplate_1.default)(trackVideoShareLink.href, { id: videoId }), {});
    }
}
exports.ApiShareLinksClient = ApiShareLinksClient;
//# sourceMappingURL=ApiShareLinksClient.js.map